import type { CountryCode, RegionCode } from '@/graphql/api'
import { noPrefixRegion } from '@/plugins/region.ts'

export const regionRepresentingCountry: Record<RegionCode, CountryCode> = {
    INT: 'ZW',
    US: 'US',
    UK: 'GB',
    EU: 'BG',
    IE: 'IE',
    NZ: 'NZ',
    AU: 'AU',
    CA: 'CA',
    ZA: 'ZA',
}

export function getCountryFromRegionCode(regionCode: RegionCode): CountryCode {
    return regionRepresentingCountry[regionCode]
}

export function getRegionCodeForCountry(countryCode: CountryCode): RegionCode {
    switch (countryCode) {
        case 'US':
            return 'US'
        default:
            return noPrefixRegion
    }
}
